// extracted by mini-css-extract-plugin
export default {"item__box":"style_item__box__4qXmR"};